export interface SignaturePadRequest {
    type: SignatureOrigin;
    canEmptySign: boolean;
    labelInfo: string;
    image: string | null;
    skip: boolean;
}

export enum SignatureOrigin {
    CLIENT = 'CLIENT',
    DOCTOR = 'DOCTOR',
    LEGAL_REP = 'LEGAL_REP',
}

export function isSignaturePadRequest(obj: any): obj is SignaturePadRequest {
    if (obj) {
        return (obj as SignaturePadRequest).labelInfo !== undefined;
    }
    return false;
}
